import * as tax from './tax';
import * as auth from './auth';
import * as mail from './mail';
import * as payment from './payment';
import * as notifications from './notifications';

export const api = {
  tax,
  mail,
  auth,
  payment,
  notifications,
};
